import { useQuery } from "@tanstack/react-query";

import {
  getUsers,
  type SortOrder,
  type UserListSortColumn,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export interface UsersQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string | null;
  sortBy?: UserListSortColumn;
  sortOrder?: SortOrder;
}

export const USERS_QUERY_KEYS = {
  all: ["USERS"] as const,
  list: (params: UsersQueryParams) =>
    [...USERS_QUERY_KEYS.all, "LIST", params] as const,
} as const;

export function useUsersQuery(params: UsersQueryParams) {
  return useQuery({
    queryKey: USERS_QUERY_KEYS.list(params),
    queryFn: processResponse(() =>
      getUsers(
        params.offset,
        params.limit,
        params.searchQuery,
        params.sortBy,
        params.sortOrder,
      ),
    ),
  });
}
